module.exports = (s) => {
  return [
    {
      name: '角色ID',
      value: 'id',
      width: 80,
    },
    {
      name: '角色名称',
      value: 'name',
    },
    {
      name: '菜单权限',
      format: (row) => {
        const { id, permissions: { menu }} = row;
        const h = s.$createElement;
        const ele = id === 1 ? h('span', null, '全权限') : h(
          'el-select',
          {
            props: {
              placeholder: '查看角色菜单权限',
              size: 'mini',
              filterable: true,
              value: null,
            },
          },
          menu.map(({ name, id }) => {
            return h('el-option', {
              props: {
                label: name,
                value: id,
              },
            }, null);
          }));
        return ele;
      },
    },
    {
      name: '功能权限',
      format: (row) => {
        const { id, permissions: { api }} = row;
        const h = s.$createElement;
        const ele = id === 1 ? h('span', null, '全权限') : h(
          'el-select',
          {
            props: {
              placeholder: '查看角色功能权限',
              size: 'mini',
              filterable: true,
              value: null,
            },
          },
          api.map(({ name, id }) => {
            return h('el-option', {
              props: {
                label: name,
                value: id,
              },
            }, null);
          }));
        return ele;
      },
    },
    {
      name: '游戏权限',
      format: (row) => {
        const { id, permissions: { games = [] }} = row;
        const h = s.$createElement;
        const ele = (id === 1 || games.length === 0) ? h('span', null, '全权限') : h(
          'el-select',
          {
            props: {
              placeholder: '查看角色游戏权限',
              size: 'mini',
              filterable: true,
              value: null,
            },
          },
          games.map(({ name, id }) => {
            return h('el-option', {
              props: {
                label: `${id} ${name}`,
                value: id,
              },
            }, null);
          }));
        return ele;
      },
    },
    {
      name: '操作',
      width: 220,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            plain: true,
            disabled: row.id === 1,
          },
          on: {
            click: () => {
              s?.assignPermission(row);
            },
          },
        }, '分配权限');
        const assign_game_btn = h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            plain: true,
            disabled: row.id === 1,
          },
          on: {
            click: () => {
              s?.openAssignGamesDialog(row);
            },
          },
        }, '分配游戏权限');
        return h('div', null, [assign_game_btn, ele]);
      },
    },
  ];
};
